import { Component, HostListener } from '@angular/core';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import { Events, IonicPage, LoadingController, ModalController, NavController, NavParams, Platform, ViewController } from 'ionic-angular';
import moment from 'moment';
import { expandVertical } from '../../../animations/appear-animation';
import { AuthenticationBloc } from '../../../bloc/authentication/authentication.bloc';
import { InitializeBloc } from '../../../bloc/authentication/initialize.bloc';
import { MultipleAccountBloc, SwitchAccountResponse } from '../../../bloc/authentication/multiple-account.bloc';
import { CompanyBloc } from '../../../bloc/company/company.bloc';
import { CompanyMoodBloc } from '../../../bloc/feature/company-mood/company-mood.bloc';
import { HomeBloc } from '../../../bloc/feature/home/home.bloc';
import { FavoriteMenuItem } from '../../../bloc/feature/home/home.dto';
import { ProfileBloc } from '../../../bloc/feature/profile/profile.bloc';
import { TrackerBloc } from '../../../bloc/feature/tracker/tracker.bloc';
import { AttendanceBloc } from '../../../bloc/hr/attendance/attendance.bloc';
import { GoogleAccountBloc } from '../../../bloc/settings/google-account.bloc';
import { EventLabel } from '../../../helpers/event-label';
import { EventNameAnalytics } from '../../../helpers/event-name-analytics';
import { Messages } from '../../../helpers/messages';
import { OptionUpdateUserIntercom } from '../../../model/intercome.model';
import { ScreenshotNative } from '../../../native/screenshot.native';
import { PageBuilderMenuProvider } from '../../../pagebuilder/services/menu/repository';
import { AlertServiceProvider } from '../../../providers/alert-service/alert-service';
import { AnalyticsProvider } from '../../../providers/analytics/analytics';
import { AppGuideProviders } from '../../../providers/app-guide/appGuideProviders';
import { ChatSupportService } from '../../../providers/chat-support/chat-support-service';
import { GamificationProvider } from '../../../providers/gamification/gamification';
import { GlobalServiceProvider } from '../../../providers/global-service/global-service';
import { InappbrowserService } from '../../../providers/inappbrowser/inappbrowser.service';
import { LoadingServiceProvider } from '../../../providers/loading-service/loading-service';
import { NavigationService } from '../../../providers/navigation/navigation';
import { PermissionCheckProvider } from '../../../providers/permission-check/permission-check';
import { PlatformServiceProvider } from '../../../providers/platform/platform-service';
import { Sunfish7Provider } from '../../../providers/sunfish7/sunfish7.provider';
import { WorklocationServiceProvider } from '../../../providers/worklocation/worklocation.service';
import { AppPreferences, Preference } from '../../../shared/local/app-preferences.local';
import { AttendanceRedirectPage, ResponseNewTodayAttendance } from '../../../shared/nestjs/gd-only/dto/attendance.dto';
import { badgeModule } from '../../../shared/nestjs/gd-only/dto/gamification.dto';
import { NestResponsesProvider } from '../../../shared/nestjs/nest-responses';
import { ResponseModalSingout } from './modal-singout/modal-singout';
declare var require: any
const IntroJs = require("../../../../node_modules/intro.js");

/**
 * Generated class for the HomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  animations: [expandVertical]
})
export class HomePage {
  public attendanceData: ResponseNewTodayAttendance;
  public partnerCovid: any;
  public isSwitchCompany: boolean;
  public companySelected: any;
  public companyList = [];
  public breakAt: boolean = false;
  public currentReload = moment();
  public isFirstVisit = true;
  public attendanceOfflineList = [];
  public isSyncAttendance = false;
  private timeoutRefresher = 2000;
  public tab: any;
  public showAttendance: boolean = false;
  sosPosition: any = {
    top: '275px',
    right: ''
  }
  public showPanicButton: boolean = false;
  public showShift: boolean = false;
  public showWorkLocation: boolean = false;
  public labelWorkLocation: string;
  public permissionBackgroundLocation = { hasPermission: false };
  public isSF7: boolean = false;

  constructor(
    private viewCtrl: ViewController,
    public attendanceBloc: AttendanceBloc,
    public appPreferences: AppPreferences,
    private platform: Platform,
    public homeBloc: HomeBloc,
    public profileBloc: ProfileBloc,
    public companyBloc: CompanyBloc,
    private analyticsProvider: AnalyticsProvider,
    private inAppBrowserService: InappbrowserService,
    private events: Events,
    private companyMoodBloc: CompanyMoodBloc,
    private gamificationProvider: GamificationProvider,
    private initializeBloc: InitializeBloc,
    private menuRepository: PageBuilderMenuProvider,
    private nestResponses: NestResponsesProvider,
    private modalCtrl: ModalController,
    private multipleAccountBloc: MultipleAccountBloc,
    private authenticationBloc: AuthenticationBloc,
    private globalService: GlobalServiceProvider,
    private chatSupportService: ChatSupportService,
    private navigationService: NavigationService,
    public appGuideProviders: AppGuideProviders,
    public translate: TranslateService,
    public navCtrl: NavController,
    public navParams: NavParams,
    public permissionCheck: PermissionCheckProvider,
    public loadingController: LoadingController,
    public storage: Storage,
    public loadingService: LoadingServiceProvider,
    public alertService: AlertServiceProvider,
    public platformServiceProvider: PlatformServiceProvider,
    public trackerBloc: TrackerBloc,
    public googleAccountBloc: GoogleAccountBloc,
    private screenshotNative: ScreenshotNative,
    private sunfish7Provider: Sunfish7Provider,
    private worklocationServiceProvider: WorklocationServiceProvider,
  ) { }

  ngOnInit() {
    this.eventListener();
    this.checkAttOfflineData();
    this.tab = this.navCtrl.parent;
    this.showAttendanceAfterSurvey();
    this.reStartBackgroundTracking();
    this.alertLink();
    this.isSF7 = this.appPreferences.dataAuth && this.appPreferences.dataAuth.isSF6 &&
      (this.appPreferences.dataAuth.sfversion && Math.floor(Number(this.appPreferences.dataAuth.sfversion))) >= 7 ? true : false;
    this.attendanceBloc.setBasePhoto();
    this.worklocationServiceProvider.todayForm();
  }

  ngAfterViewInit() {
    this.authenticationBloc.tokenFCM();
    this.analyticsProvider.setUserPropertyAnalytics();
  }

  initView() {
    this.panicPanGesture();
  }

  async ionViewWillEnter() {
    const reloadTabs = this.homeBloc.reloadTabs(this.currentReload);
    this.currentReload = reloadTabs.currentReload;

    if (reloadTabs.reload || this.isFirstVisit) {
      this.getData();
    }
  }

  get nickName() {
    let nickName = '';
    try {
      if (this.profileBloc.myProfile && this.profileBloc.myProfile.nickname) {
        nickName = this.profileBloc.myProfile.nickname;
      } else {
        nickName = this.profileBloc.myProfile.fullName.split(' ')[0];
      }
    } catch (error) {
      nickName = this.profileBloc.myProfile && this.profileBloc.myProfile.fullName ? this.profileBloc.myProfile.fullName : '-';
    }

    return nickName;
  }

  panicPanGesture() {
    let panic = document.getElementById('panic');
    if (panic) {
      let mc = new window['Hammer'](panic);
      mc.add(new window['Hammer'].Pan({ direction: window['Hammer'].DIRECTION_ALL, threshold: 0 }));
      mc.on('pan', (ev) => {
        this.sosPosition.top = (ev.srcEvent.clientY - (panic.clientHeight / 2)) + 'px';
      })
    }
  }

  async getData() {
    try {
      this.isFirstVisit = false;
      this.companySelected = this.appPreferences.dataAuth.accId || this.appPreferences.dataAuth.companyId;
      this.companyList = this.appPreferences.dataAuth.multiCompany && this.appPreferences.dataAuth.multiCompany.company_list
        ? this.appPreferences.dataAuth.multiCompany.company_list
        : this.companyList;

      this.homeBloc.getFavoriteMenu();
      this.attendanceBloc.doGetTodayShift();
      this.companyBloc.doGetMyCompany();
      this.homeBloc.getBadgeApproval();
      this.doGetTodayAttendance();
      this.getUserAccess();
      this.getLocation();
      try {
        if (this.platform.is('cordova')) {
          this.loadSettingScreenshot(this.appPreferences.dataAuth.companySetting.preventScreenshot);
          if (this.appPreferences.dataAuth.companySetting.checkSimCard) {
            // this.simProvider.checkSimCard();
          }
        }

        this.isSF7 = this.appPreferences.dataAuth && this.appPreferences.dataAuth.isSF6 &&
          (this.appPreferences.dataAuth.sfversion && Math.floor(Number(this.appPreferences.dataAuth.sfversion))) >= 7 ? true : false;
        this.attendanceBloc.setBasePhoto();
      } catch (_) { }

      await this.requestPermissionBackgroundLocation();
      this.checkPollingAfterLogin();
    } catch (error) {
      console.log('TCL error get data', error)
    }
  }

  async doRecordAttendance() {
    const checkPermissionBackgroundLocation = await this.requestPermissionBackgroundLocation();
    if (!checkPermissionBackgroundLocation.hasPermission) return;

    const showBefore = await this.checkPollingBeforeAttendance();
    if (showBefore) {
      const result = await this.attendanceBloc.doRecordAttendance();
      if (!result.cancelled) {
        if (!this.platform.is('cordova')) {
          this.navigationService.openPage(result.page, result.params, result.navType, result.onDidDismiss);
          this.handleRecordAttendanceWeb(result);
        } else {
          this.redirectAttendancePage(result);
        }
      }
    }
  }

  async checkPolicyLocation() {
    if (this.platform.is('cordova') && this.platform.is('android')) {
      const checkPermission = await this.permissionCheck.checkPermissionBackgroundLocation();
      if (this.appPreferences.dataAuth && this.appPreferences.dataAuth.menu['tracking']) {
        const policyBackgroundLocation = await this.appPreferences.getGreatdayStorage(Preference.PolicyBackgroundLocation);
        console.log('check background location', policyBackgroundLocation);
        if (!policyBackgroundLocation && !checkPermission.hasPermission) {
          await this.openPolicyRequestPermission();
          return true;
        }
      }
    }

    return false;
  }

  async doGetTodayAttendance() {
    try {
      await this.attendanceBloc.doGetTodayAttendance(this.appPreferences.dataAuth.empId);
    } catch (error) {
      await this.nestResponses.error(error);
      const msg = this.nestResponses.handleMsgError(error);
      if (msg.includes('Please re-login')) {
        this.events.publish('user:logout', true);
      }
    }
  }

  async handleRecordAttendanceWeb(result) {
    if (!this.platform.is('cordova')) {
      const data = await this.homeBloc.afterPageDismiss(result.page);
      if (data !== undefined) {
        const result = await this.attendanceBloc.processAttWeb(data);
        if (!result.cancelled) {
          this.redirectAttendancePage(result);
        }
      }
    }
  }

  async redirectAttendancePage(result: AttendanceRedirectPage) {
    try {
      const companySetting = this.appPreferences.dataAuth && this.appPreferences.dataAuth.companySetting;
      const worklocConfirm = companySetting && companySetting.wlc ? companySetting.wlc : false;
    
      if (worklocConfirm) {
        const todayForm = await this.appPreferences.getGreatdayStorage(Preference.GDAttendanceTodayForm) as Array<any>;
        const startTime = this.attendanceBloc.todayAttendance && this.attendanceBloc.todayAttendance.today && this.attendanceBloc.todayAttendance.today.starttime;
        if (todayForm && todayForm.length && !startTime) {
          this.navigationService.openPage('TimeAttendanceWorklocPage', { attendanceRedirectPage: result, todayForm });
        } else {
          this.navigationService.openPage(result.page, result.params, result.navType, result.onDidDismiss);
        }
      } else {
        this.navigationService.openPage(result.page, result.params, result.navType, result.onDidDismiss);
      }
    } catch (error) {
      this.navigationService.openPage(result.page, result.params, result.navType, result.onDidDismiss);
    }
  }

  async checkPollingAfterLogin() {
    const result = await this.homeBloc.checkPollingAfterLogin();
    if (result.page) {
      const type = result.restrict ? 'setRoot' : 'push';
      this.navigationService.openPage(result.page, result.params, type);
    } else {
      this.openBoarding();
    }
  }

  async checkPollingAfterAttendance() {
    const result = await this.homeBloc.checkPollingAfterAttendance();
    if (result.page) {
      const type = result.restrict ? 'setRoot' : 'push';
      this.navigationService.openPage(result.page, result.params, type);
    }
  }

  async checkPollingBeforeAttendance() {
    const result = await this.homeBloc.checkPollingBeforeAttendance();
    if (result.page) {
      const type = result.restrict ? 'setRoot' : 'push';
      this.navigationService.openPage(result.page, result.params, type);
      await this.homeBloc.afterPageDismiss(result.page);

      const surveyCode = result.params.surveyCode || null;
      this.homeBloc.setPollingStorage(surveyCode);
      return false;
    }
    return true;
  }


  eventListener() {
    // Switch account
    this.events.unsubscribe(EventLabel.SWITCH_ACCOUNT_RELOAD_HOME);
    this.events.subscribe(EventLabel.SWITCH_ACCOUNT_RELOAD_HOME, () => {
      this.getData();
    });

    // Switch account reload configure app
    this.events.unsubscribe(EventLabel.SWITCH_ACCOUNT_RELOAD);
    this.events.subscribe(EventLabel.SWITCH_ACCOUNT_RELOAD, (data: SwitchAccountResponse) => {
      this.switchAccountReload(data);
    });

    // Switch company reload configure app
    this.events.unsubscribe(EventLabel.COMPANY_SWITCH);
    this.events.subscribe(EventLabel.COMPANY_SWITCH, (companyId: string) => {
      this.changeCompany(companyId);
    });

    // record attendance
    this.events.unsubscribe(EventLabel.ATTENDANCE_RECORD_ATTENDANCE);
    this.events.subscribe(EventLabel.ATTENDANCE_RECORD_ATTENDANCE, () => {
      this.isSyncAttendance = true;
    });

    // attendance check offline data
    this.events.unsubscribe(EventLabel.ATTENDANCE_CHECK_OFFLINE_DATA)
    this.events.subscribe(EventLabel.ATTENDANCE_CHECK_OFFLINE_DATA, async () => {
      this.isSyncAttendance = false;
      this.attendanceOfflineList = await this.appPreferences.getGreatdayStorage<any>(Preference.GDAttendanceOffline);
    });

    // Listener after success record attendance
    this.events.unsubscribe(EventLabel.ATTENDANCE_SUCCESS_RECORD);
    this.events.subscribe(EventLabel.ATTENDANCE_SUCCESS_RECORD, async (val) => {
      if (val) {
        // check uptodate data attendance
        this.attendanceBloc.doGetTodayAttendance(this.appPreferences.dataAuth.empId);

        // Check survey employee company mood
        const authCompanyMode = this.appPreferences.dataAuth.menu["company-mood"];
        if (authCompanyMode) {
          await this.companyMoodBloc.checkEmployeeSurvey();
        }

        // check gamification
        if (!this.attendanceBloc.todayAttendance.today.actualOut && this.appPreferences.dataAuth.menu['gamification']) {
          await this.gamificationProvider.checkAchievement(badgeModule.attendanceIn);
        }

        // check survey polling after attendance
        await this.checkPollingAfterAttendance();

        this.showRating();
      }
    });
  }

  async openPage(page: FavoriteMenuItem) {
    this.homeBloc.updateStorageAuthSF6();
    page.typeMenu = 'push';
    let isSF7 = false;

    if (page.pageStatic == "leave2Page") {
      if (this.appPreferences.dataAuth && this.appPreferences.dataAuth.isSF6 && this.appPreferences.dataAuth.sfversion && Math.floor(Number(this.appPreferences.dataAuth.sfversion)) >= 7) {
        isSF7 = true;
        this.sunfish7Provider.openPage('standard/hrm.time-and-attendance.attendance-request.leave-request');
      } else {
        isSF7 = false;
        page.params = { empid: this.appPreferences.dataAuth.empId, isProfile: true };
      }
    } else if (page.title == "Request") {
      page.params = { flag: 0, empid: this.appPreferences.dataAuth.empId, userid: this.appPreferences.dataAuth.userId };
    } else if (page.pageStatic == "ClaimRequestPage") {
      page.pageStatic = this.appPreferences.dataAuth.isSF6 ? 'ClaimRequestSF6Page' : page.pageStatic;
      page.params = { flag: 0, empid: this.appPreferences.dataAuth.empId, userid: this.appPreferences.dataAuth.userId };
    } else if (page.title == "Attendance") {
      page.pageStatic = this.appPreferences.dataAuth.isSF6 ? page.pageStatic : 'TimeAttendanceSfgoPage';
      page.params = { flag: 0, empid: this.appPreferences.dataAuth.empId, userid: this.appPreferences.dataAuth.userId };
    } else if (page.pageStatic === "covid19") {
      this.homeBloc.goToCovid19();
    } else if (page.pageStatic == 'yesdok') {
      this.homeBloc.goToYesdok();
    } else if (page.pageStatic == 'dnatest') {
      const loading = this.loadingController.create();
      await loading.present();
      await this.homeBloc.goToAsaren('symptom');
      await loading.dismiss();
    } else if (page.pageStatic == 'questionaire') {
      const loading = this.loadingController.create();
      await loading.present();
      await this.homeBloc.goToAsaren('chat');
      await loading.dismiss();
    } else if (page.pageStatic == 'healthform') {
      await this.homeBloc.goHealthForm();
    } else if (page.pageStatic == "OvertimeHistoryPage2SF6") {
      if (this.appPreferences.dataAuth && this.appPreferences.dataAuth.isSF6 && this.appPreferences.dataAuth.sfversion && Math.floor(Number(this.appPreferences.dataAuth.sfversion)) >= 7) {
        isSF7 = true;
        this.sunfish7Provider.openPage('standard/hrm.time-and-attendance.attendance-request.overtime-request');
      } else {
        isSF7 = false;
      }
    } else if (page.pageStatic == "Payroll2Page") {
      if (this.appPreferences.dataAuth && this.appPreferences.dataAuth.isSF6 && this.appPreferences.dataAuth.sfversion && Math.floor(Number(this.appPreferences.dataAuth.sfversion)) >= 7) {
        isSF7 = true;
        this.sunfish7Provider.openPage('standard/hrm.payroll.my-payroll-info');
      } else {
        isSF7 = false;
      }
    }

    if (
      !isSF7 &&
      page.pageStatic !== "covid19" &&
      page.pageStatic !== "yesdok" &&
      page.pageStatic !== "dnatest" &&
      page.pageStatic !== "questionaire" &&
      page.pageStatic !== "healthform"
    ) {
      const type = page.typeMenu === 'push' ? 'push' : 'setRoot';
      this.navigationService.openPage(page.pageStatic, page.params, type);
    }

    this.analyticsProvider.trackEvent(EventNameAnalytics.OPEN_MENU, page.title);
  }

  @HostListener('window:click', ['$event'])
  onClickYesdok(e) {
    if (e.target.className == 'termYesdok activated') {
      this.inAppBrowserService.openInAppBrowser('https://www.yesdok.com/id/tnc.html', '_blank')
    }
  }

  openSearchPage() {
    this.navigationService.push('EmpListPage', { popBack: this.viewCtrl });
  }

  async openProfilePage() {
    if (this.appPreferences.dataAuth && this.appPreferences.dataAuth.isSF6 && this.appPreferences.dataAuth.sfversion && Math.floor(Number(this.appPreferences.dataAuth.sfversion)) >= 7) {
      this.sunfish7Provider.openPage('standard/user-profile')
    } else {
      this.navigationService.push('ProfileHomePage');
      await this.homeBloc.afterPageDismiss('ProfileHomePage');
    }
  }

  openSwitchCompany() {
    const modal = this.modalCtrl.create(
      'MultiCompanyPage', { companyList: this.companyList, companySelected: this.companySelected },
      {
        cssClass: 'grd-modal-rating'
      }
    );

    modal.onDidDismiss((response) => {
      if (response) {
        this.changeCompany(response.companyId);
      }
    })
    modal.present();
  }

  async changeCompany(value) {
    try {
      this.isSwitchCompany = true;
      this.navigationService.push('ProgressbarPage', { isSwitchCompany: true });
      await this.initializeBloc.switchCompany(value);
      await this.menuRepository.updateAuthFavoriteMenu();
      await this.initializeBloc.setConfig();
      this.getData();
    } catch (error) {
      this.nestResponses.error(error);
    } finally {
      this.isSwitchCompany = false;
      this.events.publish(EventLabel.COMPANY_SWITCH_DONE);
    }
  }

  modalProfile() {
    const modal = this.modalCtrl.create('ModalSingoutPage');
    modal.onDidDismiss((data) => {
      if (data) {
        this.modalProfileRedirect(data);
      }
    });

    modal.present();
  }

  openPolicy() {
    const modal = this.modalCtrl.create('PrivacyPolicyPage', {}, {
      cssClass: 'grd-modal-privacy',
      showBackdrop: true,
      enableBackdropDismiss: false
    });
    modal.onDidDismiss((data) => {
      if (data) {
        console.log(data);
      }
    });

    modal.present();
  }

  modalWorkPlace() {
    const modal = this.modalCtrl.create('WorkPlacePage');
    modal.onDidDismiss(() => {
    });
    modal.present();
  }

  modalShift() {
    const modal = this.modalCtrl.create('ShiftModalPage');
    modal.onDidDismiss(() => {
    });
    modal.present();
  }

  modalProfileRedirect(value) {
    switch (value) {
      case ResponseModalSingout.PROFILE:
        this.openProfilePage();
        break;
      case ResponseModalSingout.SUPPORT:
        this.openSupport();
        break;
      case ResponseModalSingout.SETTING:
        this.openSetting();
        break;
      case ResponseModalSingout.LOGOUT:
        this.events.publish('user:logout');
        break;
      default:
        break;
    }
  }

  async openSupport() {
    const menu = this.appPreferences.dataAuth.menu;
    const authorized = menu.hasOwnProperty('intercom') ? menu['intercom'] : false;

    if (authorized) {
      await this.loadingService.presentLoadingDefault();
      if (this.platform.is('cordova')) {
        await this.initializeBloc.setAppVersion();
        const { isUptodate, intercomUpdate, message } = await this.initializeBloc.checkAppVersionForIntercom();

        if (intercomUpdate && !isUptodate) {
          this.globalService.showConfirmUpdateApps(false, message);
        } else {
          this.initializeChatSupport();
        }
      } else {
        this.initializeChatSupport();
      }
    } else {
      this.navigationService.push('ProblemOptionsPage', { from: 'menu' });
    }
  }

  async initializeChatSupport() {
    const options: OptionUpdateUserIntercom = {
      userId: this.appPreferences.dataAuth.userId,
      name: this.appPreferences.dataAuth.fullName,
      email: this.appPreferences.dataAuth.email,
      companies: [
        {
          name: this.appPreferences.dataAuth.saasData.ACCOUNTNAME,
          company_id: this.appPreferences.dataAuth.saasData.IST
        }
      ]
    };

    await this.chatSupportService.setIdentity(options.name, options.email);
    this.chatSupportService.showChat();
    this.loadingService.dismissLoading();
  }

  openSetting() {
    this.navigationService.push('SettingPage');
  }

  openbreakAt() {
    this.breakAt = !this.breakAt;
  }

  async switchAccountReload(data: SwitchAccountResponse) {
    try {
      console.log('switchAccountReload');

      // load auth
      const auth = await this.authenticationBloc.loadAuthSwitchAccount();

      // publish event get menu pagebuilder
      this.events.publish(EventLabel.USER_CREATED, auth);
      if (this.platform.is('android')) {
        await this.initializeBloc.getWhiteList();
        await this.initializeBloc.sendIndicatedMock();
      }

      if (this.platform.is('cordova')) {
        this.globalService.splashScreenDownload();
      }

      await this.initializeBloc.setConfig();
      await this.attendanceBloc.findAttWorkLocation();
      await this.multipleAccountBloc.updateStorageMultipleAccount(data);
      await this.multipleAccountBloc.fcmRegisterToken(data.accountToSwitch);
      this.getData();
    } catch (error) {
      this.multipleAccountBloc.rollBackSwitchAccount(data);
      this.attendanceBloc.nestApiProvider.responseError(error);
    } finally {
      this.events.publish(EventLabel.MULTIACCOUNT_SWITCH_DONE);
    }
  }

  async doRefresh(refresher) {

    this.isFirstVisit = false;
    this.companySelected = this.appPreferences.dataAuth.accId || this.appPreferences.dataAuth.companyId;

    this.companyList = this.appPreferences.dataAuth.multiCompany && this.appPreferences.dataAuth.multiCompany.company_list
      ? this.appPreferences.dataAuth.multiCompany.company_list
      : this.companyList;

    this.checkAttOfflineData();
    await this.attendanceBloc.findAttWorkLocation();
    this.getLocation();
    this.companyBloc.doGetMyCompany();
    this.homeBloc.getFavoriteMenu();
    this.homeBloc.getBadgeApproval();
    this.doGetTodayAttendance();
    this.attendanceBloc.doGetTodayShift();
    this.attendanceBloc.getCompanySetting();
    this.attendanceBloc.isRunRecordTime = false;
    this.attendanceBloc.setBasePhoto();
    setTimeout(() => {
      refresher.complete();
    }, this.timeoutRefresher);
  }

  /** Check Attendance Offline Data */
  async checkAttOfflineData() {
    try {
      const attOffline = await this.appPreferences.getGreatdayStorage<any>(Preference.GDAttendanceOffline);
      if (attOffline instanceof Array && attOffline.length) {
        this.attendanceOfflineList = attOffline.reverse();
        const confirm = await this.alertService.confirmMessage(Messages.CONFIRM_SEND_OFFLINE_ATTENDANCE);
        if (confirm) {
          this.events.publish('OFFLINEMODE:RUNSYNCATTENDANCEOFFLINERECORD', this.attendanceOfflineList)
        }
      } else {
        this.attendanceOfflineList = [];
      }
    } catch (error) {
      this.attendanceOfflineList = [];
    }
  }

  openOfflineList() {
    const modal = this.modalCtrl.create('OfflineModeListPage', { mode: 'modal' }, { cssClass: "gd-modal-radius" });
    modal.onDidDismiss(async () => {
      this.attendanceOfflineList = await this.appPreferences.getGreatdayStorage<any>(Preference.GDAttendanceOffline);
    })
    modal.present();
  }

  async openBoarding() {
    const statusGuide = localStorage.getItem('guide-tabs');
    if (statusGuide || !this.permissionBackgroundLocation.hasPermission) return;

    // modal onboarding home tab
    const modal = this.modalCtrl.create(
      'HomeOnboardingModalPage', {},
      {}
    );
    modal.onDidDismiss(async res => {
      if (res) {
        this.openGuide();
      }
    })
    modal.present();
  }

  async openGuide(): Promise<void> {
    const intro = IntroJs.introJs();
    let steps = [];
    let showTeammates = false;

    try {
      if (this.appPreferences.dataAuth && this.appPreferences.dataAuth.menu) {
        showTeammates = this.appPreferences.dataAuth.menu['team-mates'] !== undefined ? this.appPreferences.dataAuth.menu['team-mates'] : false;
      }
    } catch (error) {
      showTeammates = false;
    }

    try {
      await steps.push({
        title: 'Record your attendance faster 🤳',
        element: '#att-btn-intro',
        intro: '<b>' + this.translate.instant('Record your attendance faster') + '🤳</b></br>' + this.translate.instant("Easiness at your fingertip! You can record attendance faster with no hasle. Just take a selfie and you are ready to work."),
        position: 'top',
      });
      await steps.push({
        title: 'Better navigation system 📲',
        element: '#tabs-intro',
        intro: '<b>' + this.translate.instant('Better navigation system') + '📲</b></br>' + this.translate.instant("You can easily explore the features which are grouped according to your needs."),
        position: 'bottom',
      });
      await steps.push({
        title: 'An easier way to browse features ⚙️',
        element: '#tab-t0-1',
        intro: '<b>' + this.translate.instant('An easier way to browse features') + '⚙️</b></br>' + this.translate.instant("All features are now in one tab! you can access them easily and quickly."),
        position: 'bottom',
      });
      await steps.push({
        title: 'Seamless workplace grouping 🧑‍💻',
        element: '#tab-t0-3',
        intro: '<b>' + this.translate.instant('Seamless workplace grouping') + '🧑‍💻</b></br>' + this.translate.instant("No more confusion, cause you can find all the features related to your company here."),
        position: 'bottom',
      });

      if (showTeammates) {
        await steps.push({
          title: 'Stay connected with your co-workers 👫',
          intro: '<b>' + this.translate.instant('Stay connected with your co-workers') + '👫</b></br>' + this.translate.instant("From assigning task, monitoring, to giving feedback to your team, everything can be done in one click away."),
          preChange: function () {
            this.element = document.querySelector('#teammates-intro');
            this.position = 'bottom';
          }
        });
      }

      intro.setOptions({
        steps: steps,
        showProgress: false,
        exitOnOverlayClick: false,
        doneLabel: this.translate.instant("Done"),
        nextLabel: this.translate.instant("Next"),
        prevLabel: this.translate.instant("Back"),
        overlayOpacity: "0.8",
        showStepNumbers: false
      });

      intro.onbeforechange(function () {
        if (this._introItems[this._currentStep].preChange) {
          this._introItems[this._currentStep].preChange();
        }
      })

      intro.onchange((targetElement) => {
        if (targetElement.getAttribute("id") === 'tab-t0-3') {
          this.tab.select(3);
        } else if (targetElement.getAttribute("id") === 'tab-t0-1') {
          this.tab.select(1);
        }
      });

      intro.oncomplete(() => {
        localStorage.setItem('guide-tabs', '1');
      });

      intro.onexit(() => {
        localStorage.setItem('guide-tabs', '1');
      });

      setTimeout(() => {
        intro.start();
      }, 300);
    } catch (error) {
      steps = [];
    }
  }

  showAttendanceAfterSurvey() {
    const isShow = localStorage.getItem('openAttendance');
    if (isShow === 'true') {
      localStorage.setItem('openAttendance', null);
      this.doRecordAttendance();
    }
  }

  getUserAccess() {
    const listMenu = this.appPreferences.dataAuth.menu;
    if (listMenu["att-entry"] != undefined) {
      this.showAttendance = listMenu["att-entry"];
    }

    if (listMenu["home-shift"] != undefined) {
      this.showShift = listMenu["home-shift"];
    }

    if (this.appPreferences.dataAuth && this.appPreferences.dataAuth.isSF6 && this.appPreferences.dataAuth.sfversion && Math.floor(Number(this.appPreferences.dataAuth.sfversion)) >= 7) {
      this.showPanicButton = false;
    } else {
      let tempMenuName = "panicbutton";
      if (this.platform.is('cordova')) {
        this.showPanicButton = listMenu[tempMenuName] || false;
      } else {
        tempMenuName = "panicbutton-web";
        this.showPanicButton = listMenu[tempMenuName] || false;
      }
    }

    this.showWorkLocation = this.appPreferences.dataAuth.companySetting.attendanceLock || this.appPreferences.dataAuth.companySetting.attendanceLockPrompt;
  }

  gotoPanicButton() {
    this.navCtrl.push("PanicButtonPage");
  }

  async openPolicyRequestPermission() {
    await this.navigationService.push('PolicyLocationPermissionPage');
    await this.homeBloc.afterPageDismiss('PolicyLocationPermissionPage');
    this.requestPermissionBackgroundLocation();
  }

  async getLocation() {
    try {
      const data = JSON.parse(await this.storage.get('attWorkLocation'));
      console.log('getLocation', data);
      const labelWork = data.data.find((item) => {
        return item.work_type == 'Work Location'
      });
      const labelLoc = data.data.find((item) => {
        return item.work_type == 'Attendance Location'
      });
      this.labelWorkLocation = (labelWork) ? labelWork.work_name : (labelLoc) ? labelLoc.work_name : '-';
    } catch (error) {
      this.labelWorkLocation = '-';
    }
  }

  showRating() {
    if (this.attendanceBloc.feedBack !== null && this.attendanceBloc.feedBack !== undefined) {
      this.storage.get('rating').then(data => {
        if (data == null || data == undefined) {
          let modal = this.modalCtrl.create("RatingModalPage", {}, {
            cssClass: "grd-modal-rating",
            showBackdrop: true,
            enableBackdropDismiss: true
          });
          modal.present();
        }
      })
    }
  }

  async checkPermission() {
    try {
      const result = await this.permissionCheck.checkPermissionBackgroundLocation();
      this.alertService.createMola(JSON.stringify(result));
    } catch (error) {
      console.log('TCL: error check permission', error);
    }
  }

  async requestPermissionBackgroundLocation() {
    return new Promise<{ hasPermission: boolean }>(async (resolve) => {
      try {
        const device = await this.platformServiceProvider.getPlatform();
        const androidVersion = Math.round(Number(device.Version));

        if (this.appPreferences.dataAuth && this.appPreferences.dataAuth.menu['tracking'] && androidVersion > 9) {
          const checkPermission = await this.permissionCheck.checkPermissionBackgroundLocation();

          if (!checkPermission.hasPermission) {
            this.openPolicyRequestPermission();
          }

          this.permissionBackgroundLocation.hasPermission = checkPermission.hasPermission;
        } else {
          this.permissionBackgroundLocation.hasPermission = true;
        }

        resolve(this.permissionBackgroundLocation);
      } catch (error) {
        console.log('TCL: error crequestPermissionBackgroundLocation', error);
        this.permissionBackgroundLocation.hasPermission = true;
        resolve(this.permissionBackgroundLocation);
      }
    });
  }

  async reStartBackgroundTracking() {
    try {
      await this.platform.ready();
      /** RESTART TRACKING JIKA BACKGROUND LOCATION MATI */
      if (this.platform.is('cordova')) await this.trackerBloc.reStartTracker();
    } catch (error) {
      console.log('TCL: error restartTracker');
    }
  }

  async alertLink() {
    if (this.appPreferences.dataAuth.companySetting.ssoSetting && this.appPreferences.dataAuth.companySetting.ssoSetting !== '') {
      const data = await this.googleAccountBloc.getListSSO();
      if (data && data.length === 0) {
        let modal = this.modalCtrl.create('ModalSignAlertPage', { link: 'new_user' }, { cssClass: "gd-sign-alert" });
        modal.onDidDismiss((data) => {
          return data;
        })
        if (localStorage.getItem('$account_gmail') && localStorage.getItem('$account_gmail') !== '') {
          localStorage.setItem('$account_gmail', '');
          modal.present();
        }
      }
    }
  }

  loadSettingScreenshot(setting: boolean) {
    try {
      if (setting) {
        this.screenshotNative.disabledScreenshot();
      } else {
        this.screenshotNative.enableScreenshot();
      }
    } catch (error) {
      this.screenshotNative.enableScreenshot();
    }
  }

  toProfile() {
    console.log('toProfile');
  }

  search() {
    let modal = this.modalCtrl.create('EmpListPage', { popBack: {} }, { cssClass: "" });
    modal.present();
  }

  openfeature() {
    let modal = this.modalCtrl.create('FeaturesSf7Page', {}, { cssClass: "" });
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/home-tabs/home/home.ts